(function () {
  if (window.__kvEmailFormInit) return;
  window.__kvEmailFormInit = true;

  var RESET_DELAY = 5000;

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-kv-email-form]');
    if (!form) return;
    e.preventDefault();

    var container = form.closest('.kv-email-form');
    var company = form.dataset.klaviyoCompany;
    var list = form.dataset.klaviyoList;
    var tag = (form.dataset.klaviyoTag || '').trim();
    if (!company || !list || !container) return;

    var input = form.querySelector('.kv-email-form__input');
    var button = form.querySelector('.kv-email-form__button');
    var email = (input && input.value || '').trim();
    if (!email) return;

    container.classList.remove('kv-email-form--error');
    container.classList.add('kv-email-form--loading');
    if (button) button.disabled = true;

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: tag || 'Email signup',
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: list } }
          }
        }
      })
    }).then(function (res) {
      container.classList.remove('kv-email-form--loading');
      if (res.ok || res.status === 202) {
        container.classList.add('kv-email-form--success');
        setTimeout(function () {
          container.classList.remove('kv-email-form--success');
          if (input) input.value = '';
          if (button) button.disabled = false;
        }, RESET_DELAY);
      } else {
        showError();
      }
    }).catch(function () {
      container.classList.remove('kv-email-form--loading');
      showError();
    });

    function showError() {
      container.classList.add('kv-email-form--error');
      if (button) button.disabled = false;
      setTimeout(function () {
        container.classList.remove('kv-email-form--error');
      }, RESET_DELAY);
    }
  });
})();
